var _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 100,
    viewBox: "0 0 119 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 8,
    y: 27,
    width: 66,
    height: 46,
    rx: 23,
    stroke: "#C9C9C9",
    strokeWidth: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 27,
    width: 66,
    height: 46,
    rx: 23,
    stroke: "#C9C9C9",
    strokeWidth: 12
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.ad57e058e6895b4397e2f749cbd1f11f.svg";
export { ForwardRef as ReactComponent };